// NO ACCOUNT
// pk_test_51Hm96wAWRR6JHW3MxV8Gv5jDaNrNsewaK9vsk6uWZya9VBhGEEcMBnb0SH3n1L1MCZuTYuW4qejsf0h0hVJqNkSh003hnKREnT
// NOSLEN ACCOUNT
// pk_test_51HOtBGEJ8aAMdhQQ9c4P3a41eYE4N9EYrdR4OU9OYj44gSG1FvZRt59aEa4VC80WpYIsbWt45d3LObVdCacXlBnh00CcbXeSu5
// textilelibrary-takihyo
// pk_test_51HEwsgDvDfC2dXIPF6vH4IDAFw5ohAWcowLW95NHHFXQts9IyBO0aJ0G0hepbR22aVuWwtmKuc9PYVcH5KNoVgPb009LRTY2rt
export const STRIPE_PRIVATE_KEY = "pk_test_51HEwsgDvDfC2dXIPF6vH4IDAFw5ohAWcowLW95NHHFXQts9IyBO0aJ0G0hepbR22aVuWwtmKuc9PYVcH5KNoVgPb009LRTY2rt";
